import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IconRefEnum,DateTimeService } from 'library';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  INGCarrierClientInstanceDto,
  INGCarrierClientInstanceRelationshipModel,
  RemoveTenantBusinessToBusinessRequestDto,
  SaveTenantBusinessToBusinessRequestDto,
} from '../../../interfaces/license-interfaces';
import { LicenseService } from '../../../services/license.service';
import { IBpeGridColumn } from '../../../../../../library/src/components/grid/grid.interface';
import { kebabCase } from 'lodash';
import { UserService } from '../../../services/user.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { ActivityHistoryService, ActivityKey, SearchCriteriaOperator, SearchOperator } from '../../../services/activity-history.service';
import { ActivityHistoryDialogComponent } from '../../activity-history/activity-history-dialog/activity-history-dialog.component';

dayjs.extend(utc);

declare global {
  interface Window {
      arc:any;
  }
}

@Component({
  selector: 'app-add-tenant-relationship-modal',
  templateUrl: './add-tenant-relationship-modal.component.html',
  styleUrls: ['./add-tenant-relationship-modal.component.scss'],
})
export class AddTenantRelationshipModalComponent implements OnInit, OnDestroy {
  @Input() instanceModal!: INGCarrierClientInstanceDto;

  private _subs = [] as Subscription[];
  closeIcon = IconRefEnum.BpClose;
  bpView = IconRefEnum.BpView;
  calendarIcon = IconRefEnum.BpCalendar;
  editIcon = IconRefEnum.Edit;
  editMode: boolean = false;
  expDateIsRequired: boolean = true;
  disabledKey: boolean = true;
  tenantRelations: INGCarrierClientInstanceRelationshipModel[] = [];
  addColumnDefs: IBpeGridColumn[] = [];
  editColumnDefs: IBpeGridColumn[] = [];
  pagination!: any;
  selectedClientIds: number[] = [];
  action:string = '';
  activityIcon = IconRefEnum.History;

  constructor(
    private licenseService: LicenseService,
    private dialogRef: MatDialogRef<AddTenantRelationshipModalComponent>,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private dateTimeService: DateTimeService,
    private userService: UserService,
    private activityHistoryService: ActivityHistoryService,
  ) {
  }

  ngOnInit() {
    window.arc=this
    this.defColumns()
    this.setPaginationValues();
    if(this.action === 'Add')
    {
      this.getTenantRelations();
    }
    if(this.action === 'View')
    {
      this.getExistingTenantRelations();
    }
    
  }

  ngOnDestroy() {
    this._subs.forEach((s) => s.unsubscribe());
  }

  getTenantRelations() {
    this._subs.push(
      this.licenseService
        .getTenantRelationsList(this.pagination)
        .subscribe((n) => {
          this.tenantRelations = n.items;
          this.pagination.totalRecords = n.totalRecords;
        })
    );
  }

  getExistingTenantRelations() {
    this._subs.push(
      this.licenseService
        .getExistingTenantRelationsList(this.pagination)
        .subscribe((n) => {
          this.tenantRelations = n.items;
          this.pagination.totalRecords = n.totalRecords;
        })
    );
  }

  onSave() {
    const request: SaveTenantBusinessToBusinessRequestDto = {
      nGCarrierClientInstanceId: this.instanceModal.ngCarrierClientInstanceId as number,
      nGCarrierClientInstanceIdRelations: this.selectedClientIds,
      username: this.userService.currentUserValue || '',
    };
    this._subs.push(
      this.licenseService
        .saveTenantBusinessToBusiness(request)
        .subscribe((response) => {
          if (response?.success) {
            this.toastr.success('The relationship has been saved!', 'Success');
            this.dialogRef.close({ event: 'saved-successfuly' });
          } else {
            this.toastr.error(
              response?.errorMessages[0] || 'There was an error, please try again',
              'Error'
            );
          }
        })
    );
  }

  onCloseModal(): void {
    this.dialogRef.close();
  }

  kebabCase(x: string) {
    return kebabCase(x);
  }

  defColumns() {
    if(this.action === 'Add') {
      this.addColumnDefs = [
        { title: 'Customer Name', field: 'relationCustomerName' },
        { title: 'CUSTOMER TYPE', field: 'relationCustomerType' },
        { title: 'Tenant Name', field: 'tenantName', width: 60 },
        { title: 'tenant ID', field: 'tenantID' },
        {
          title: 'STATUS', field: 'relationStatus', bodyCellTemplate: (col, row) => {
  
            return `<span class="bpe-status bpe-status-${this.kebabCase(row.relationStatus)}">
                      <span>${row.relationStatus}</span>
                    </span>`
          }
        },
      ];
    } else if (this.action === 'View') {
      this.editColumnDefs = [
        { title: 'Customer Name', field: 'relationCustomerName' },
        { title: 'CUSTOMER TYPE', field: 'relationCustomerType' },
        { title: 'Tenant Name', field: 'tenantName', width: 60 },
        { title: 'Tenant ID', field: 'tenantID' },
        {
          title: 'Last Modified Date/Time', field: 'modifyDate', bodyCellTemplate: (col, row) => {

            return this.dateTimeService.toLocalTime(row.modifyDate, true)
          }
        },
        { title: 'Last Modified By', field: 'modifiedBy' },
        {
          title: 'STATUS', field: 'relationStatus', bodyCellTemplate: (col, row) => {
  
            return `<span class="bpe-status bpe-status-${this.kebabCase(row.relationStatus)}">
                      <span>${row.relationStatus}</span>
                    </span>`
          }
        },
      ];
    }
  }

  onSortChange(event: any) {
    this.pagination.direction = event.direction
    this.pagination.sortColumn = event.sortColumn
    if(this.action === 'Add') {
      this.getTenantRelations();
    } else if (this.action === 'View') {
      this.getExistingTenantRelations();
    }
  }

  onPageChange(event: any) {
    this.pagination.page = event.page
    this.pagination.pageSize = event.pageSize
    if(this.action === 'Add') {
      this.getTenantRelations();
    } else if (this.action === 'View') {
      this.getExistingTenantRelations();
    }
  }

  onChangeFilter(searchModel: any) {
    let filters = {};
    const isNumber = (value: any) => {
      return !isNaN(value) && value.trim() !== '';
    }
    if (isNumber(searchModel?.search || '')) {
      filters = {
        tenantId: searchModel.search ? searchModel.search : void 0,
      }
    } else {
      filters = {
        relationCustomerName: searchModel.search ? searchModel.search : void 0,
        tenantName: searchModel.search ? searchModel.search : void 0,
      }
    }
    this.setPaginationValues(filters);
    if(this.action === 'Add') {
      this.getTenantRelations();
    } else if (this.action === 'View') {
      this.getExistingTenantRelations();
    }
  }

  onSelectedKeysChange($event: any) {
    this.selectedClientIds = $event.selectedIds;
  }

  setPaginationValues(searchTerm?: any) {
    this.pagination = {
      page: 1,
      pageSize: 5,
      sortColumn: 'TenantID',
      direction: 'asc',
      ...searchTerm,
      totalRecords: 0,
      nGCarrierClientInstanceID: this.instanceModal.ngCarrierClientInstanceId,
    };
  }

  openRemoveConfirmation(item: INGCarrierClientInstanceRelationshipModel) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, { disableClose: true });
    dialogRef.componentInstance.title = 'Remove Relationship';
    dialogRef.componentInstance.message =
      'Are you sure you want to remove this Relationship?';
    dialogRef.componentInstance.messageIcon = IconRefEnum.BpWarning;
    dialogRef.componentInstance.cancelBtn = 'Cancel';
    dialogRef.componentInstance.acceptBtn = 'Confirm';
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && item.ngCarrierClientInstanceBusinessToBusinessID) {
        this.removeRelationship(item);
      }
    });
  }

  removeRelationship(item: INGCarrierClientInstanceRelationshipModel) {
    const request: RemoveTenantBusinessToBusinessRequestDto = {
      nGCarrierClientInstanceBusinessToBusinessID: item.ngCarrierClientInstanceBusinessToBusinessID,
      modifiedBy: item.modifiedBy,
      nGCarrierClientInstanceName: this.instanceModal.databaseName,
      nGCarrierClientInstanceNameRelation: item.tenantName,
    };
    this._subs.push(
      this.licenseService
        .removeTenantBusinessToBusiness(request)
        .subscribe((n) => {
          if (n.success) {
            this.toastr.success('Relationship has been deleted successfully', 'Success');
            if(this.action === 'Add') {
              this.getTenantRelations();
            } else if (this.action === 'View') {
              this.getExistingTenantRelations();
            }
          } else {
            this.toastr.error( n.errorMessages[0] || 'Error deleting Relationship');
          }
        })
    );
  }

  showActivity() {
    const dialogRef = this.dialog.open(ActivityHistoryDialogComponent, {
      maxHeight: '100vh',
      disableClose: true,
    });
    dialogRef.componentInstance.classification = 'ClientTenantBusinessToBusiness';
    dialogRef.componentInstance.extraColumns = [
      {
        field: 'NGCarrierClientInstanceNameRelation',
        title: 'Client Instance Name Relation',
      },
    ]
    dialogRef.componentInstance.extraDetailHeaders = [];
    dialogRef.componentInstance.extraGridDetailHeaders = [
      {
        value: this.instanceModal.ngCarrierClientInstanceId,
        label: 'Client Instance Id'
      },
    ];
    dialogRef.componentInstance.diffConfig = {
      historicalFields: ['CreatedBy', 'CreateDate', 'ModifyDate', 'ModifiedBy'],
      onlyDateFields: [],
      customPropertyFormatters: {},
      rootPropertySection: 'Root',
    }
    dialogRef.componentInstance.extraSearchCriterias = this.activityHistoryService.buildCriteriaFilter(
      'ClientInstanceId',
      this.instanceModal.ngCarrierClientInstanceId,
    )
    dialogRef.componentInstance.filterConfig = {
      enabled: true,
      placeholder: 'Search by Description or Client Instance Name Relation',
      buildSearchCriterias: (searchValue) => {
        let criterias: any[] = [];
        if (!searchValue) {
          return criterias;
        }
        const descriptionCriteria = {
          Operator: SearchOperator.OR,
          Criteria: {
            Operator: SearchCriteriaOperator.EQ,
            Key: ActivityKey.Description,
            Value: searchValue,
          },
        };
        const inputSearchCriteria = this.activityHistoryService.buildInputCriteria(
          ['NGCarrierClientInstanceNameRelation'],
          searchValue,
          [descriptionCriteria]
        );
        criterias.push(inputSearchCriteria);
        return criterias;
      }
    }
    dialogRef.afterClosed().subscribe((statusTypeId: any) => {
      console.log('status type id', statusTypeId)
      if (statusTypeId) {}
    });
  }
}
